import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path
      fill='currentColor'
      d='M20.371 12.75H8.577v-1.5h11.794l-1.819-1.82 1.054-1.084L23.259 12l-3.653 3.654-1.054-1.085zm-5.169-3.885V5.308a.3.3 0 0 0-.086-.221.3.3 0 0 0-.222-.087H5.308a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v13.385a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h9.587a.3.3 0 0 0 .222-.087.3.3 0 0 0 .086-.22v-3.558h1.5v3.557q0 .749-.53 1.278-.53.53-1.278.53H5.308q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278V5.308q0-.748.53-1.278t1.278-.53h9.586q.749 0 1.278.53.53.53.53 1.278v3.557z'
    />
  </svg>
)
export default SvgComponent
